const facebookUrl = 'https://www.facebook.com/groups/themommymingle';

export default function WhatTheDuckHero() {
  return (
    <section className="relative min-h-[92vh] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url("https://public.readdy.ai/ai/img_res/0fdd66c47c9b7bb0e56009ab55c6976f.jpg")',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-pink-900/70 via-pink-800/60 to-yellow-900/50" />

      <div className="relative z-10 w-full text-center px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto">
        <div className="inline-flex items-center gap-2 bg-yellow-400/20 border border-yellow-300/40 text-yellow-200 text-sm font-semibold px-5 py-2 rounded-full mb-6 backdrop-blur-sm">
          <span>🦆</span>
          <span>A Mommy Mingle Community Project</span>
        </div>

        <h1 className="text-5xl sm:text-6xl lg:text-7xl font-extrabold text-white mb-4 leading-tight tracking-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
          #WhatTheDuck
        </h1>

        {/* Clear one-glance explanation */}
        <div className="bg-white/15 backdrop-blur-sm border border-white/25 rounded-2xl px-6 py-5 mb-7 max-w-2xl mx-auto">
          <p className="text-white text-base sm:text-lg font-semibold leading-relaxed">
            A real-life scavenger hunt for local families.
          </p>
          <p className="text-white/80 text-sm sm:text-base mt-2 leading-relaxed">
            Find a duck hidden somewhere in the community, log it, and either re-hide it for the next family — or keep the joy going your way.
          </p>
          <div className="flex flex-wrap justify-center gap-6 mt-4">
            <div className="flex items-center gap-2 text-yellow-200 text-sm font-medium">
              <span className="w-6 h-6 flex items-center justify-center bg-yellow-400/25 rounded-full text-xs">1</span>
              Find a duck
            </div>
            <div className="flex items-center gap-2 text-yellow-200 text-sm font-medium">
              <span className="w-6 h-6 flex items-center justify-center bg-yellow-400/25 rounded-full text-xs">2</span>
              Log your find
            </div>
            <div className="flex items-center gap-2 text-yellow-200 text-sm font-medium">
              <span className="w-6 h-6 flex items-center justify-center bg-yellow-400/25 rounded-full text-xs">3</span>
              Re-hide it or keep it
            </div>
          </div>
        </div>

        <p className="text-base sm:text-lg text-white/80 max-w-xl mx-auto leading-relaxed mb-8">
          Moms across Gwinnett County are hiding tiny rubber ducks in public places as random acts of kindness and pure fun. Because sometimes being a mom makes you wanna say... <span className="text-yellow-300 font-bold">#WhatTheDuck?!</span>
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="#gallery"
            className="px-8 py-3.5 bg-yellow-400 text-gray-900 font-bold rounded-full hover:bg-yellow-300 transition-colors cursor-pointer whitespace-nowrap text-sm"
          >
            🦆 See Found Ducks
          </a>
          <a
            href="#submit"
            className="px-8 py-3.5 bg-white/15 border border-white/40 text-white font-semibold rounded-full hover:bg-white/25 transition-colors cursor-pointer whitespace-nowrap text-sm backdrop-blur-sm"
          >
            📸 Share Your Find
          </a>
          <a
            href={facebookUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="px-8 py-3.5 bg-pink-600/80 border border-pink-400/40 text-white font-semibold rounded-full hover:bg-pink-600 transition-colors cursor-pointer whitespace-nowrap text-sm backdrop-blur-sm"
          >
            Join The Community
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-6 flex items-center justify-center text-white/60">
          <i className="ri-arrow-down-line text-2xl"></i>
        </div>
      </div>
    </section>
  );
}
